import { loadStripe } from "@stripe/stripe-js"

const publishableKey = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY

if (!publishableKey) {
  console.warn(
    "Stripe publishable key missing. Set VITE_STRIPE_PUBLISHABLE_KEY in .env"
  )
}

export const stripePromise = publishableKey
  ? loadStripe(publishableKey)
  : Promise.resolve(null)
